<template>
  <div :class="{'v-align': (!$mq.phone && $mq.tablet) || $mq.desktop}" class="columns set-password-columns">
    <div class="column info-text is-narrow">
      <h2 v-translate :class="$mq.phone ? 'heading-3' : 'heading-2'" class="paragraph-bold">
        Set new password
      </h2>
      <p v-translate :class="$mq.phone ? 'paragraph-m' : 'paragraph-l'" class="confirmation-text">
        Enter your new password. After that you can login with it.
      </p>
      <div class="form">
        <b-field
          :label="newPasswordLabel"
          :type="checkType(errors)"
          :message="displayError(errors)"
          class="field-container">
          <password-field
            name="newPassword"
            @keyup.native.enter="resetPassword()"
            @input.native="handleChangeField">
          </password-field>
        </b-field>
        <b-field>
          <button v-translate :disabled="!password" class="button is-primary save-button" @click="resetPassword()">Save password</button>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>

import PasswordField from 'top20common/components/form/PasswordField';
export default {
  props: {
    errors: Object,
    success: Boolean,
    password: String,
    resetPassword: Function,
    handleChangeField: Function
  },
  computed: {
    newPasswordLabel() {
      return this.$gettext('New Password');
    }
  },
  methods: {
    displayError(errors) {
      // Use mixin
      return errors && errors['new_password2'] ? errors['new_password2'].join(' ') : '';
    },
    checkType(errors) {
      // Use mixin
      return errors && errors['new_password2'] ? 'is-danger' : '';
    }
  },
  components: {
    PasswordField
  }
};
</script>

<style  lang="scss" scoped>
.info-text {
  max-width: 350px;
  padding: 0;
  margin: 0 auto;
}
.set-password-columns {
  margin-top: 85px;
  flex-direction: column;
  justify-content: center;
}
.confirmation-text {
  padding: 15px 0 25px 0;
}
.save-button {
  margin-top: 15px;
}
</style>
